<template>
    <v-menu offset-y max-height="250px">
        <template v-slot:activator="{ on }">
            <v-btn dark small depressed text v-on="on" class="px-3 mb-3">
                {{ activatorText }}
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                    v-for="(item, index) in itemsList"
                    :key="index"
                    link
                    :to="item.link"
                    @click="updateMenu(item)"
            >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "LinkMenu",
        props: ['items'],
        data() {
            return {
                activatorText : '',
                defaultText: this.$t('regionSearch')
            }
        },
        computed: {
            itemsList() {
                return this.items;
            },
            urlParam() {
                return this.$route.path.split('/').reverse()[0];
            },

        },
        methods: {
            checkUrl() {
                if(!this.itemsList || !this.itemsList.length) return false;

                const currentItem = this.itemsList.filter(item => {
                    return this.urlParam === item.systemName;
                })[0];

                if(!currentItem)  {
                    this.activatorText = this.defaultText;
                } else {
                    this.activatorText = currentItem.name;
                }
            },
            updateMenu(item) {
                this.activatorText = item.name;
                this.$emit('update-menu', item);
            }
        },
        created() {
            this.checkUrl();
        },
        watch: {
            itemsList() {
                this.checkUrl();
            },
            urlParam() {
                this.checkUrl();
            },
        }
    }
</script>

<style scoped>

</style>
